export default __webpack_public_path__ + "static/custom-software-solutions copy-54e3dcde869e64128b652c260cb8c34c.svg";